// Mock data for development - will be replaced with backend data

export const mockTeamMembers = [
  {
    id: 1,
    name: "John Smith",
    title: "Senior Home Loan Advisor",
    phone: "(720) 555-0101",
    email: "john.smith@pathwayhome.com",
    website: "pathwayhome.com/john-smith",
    nmls: "123456",
    photo: "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=400&h=400&fit=crop&crop=face",
    bio: "With over 15 years in mortgage lending, John specializes in VA loans and first-time homebuyer programs. As a veteran himself, he understands the unique needs of military families."
  },
  {
    id: 2,
    name: "Sarah Johnson",
    title: "Home Loan Advisor",
    phone: "(720) 555-0102",
    email: "sarah.johnson@pathwayhome.com",
    website: "pathwayhome.com/sarah-johnson",
    nmls: "234567",
    photo: "https://images.unsplash.com/photo-1494790108755-2616b612b789?w=400&h=400&fit=crop&crop=face",
    bio: "Sarah brings 10 years of experience helping families achieve homeownership. She excels in FHA loans and works closely with first-time buyers throughout Colorado."
  },
  {
    id: 3,
    name: "Michael Rodriguez",
    title: "Home Loan Advisor",
    phone: "(720) 555-0103",
    email: "michael.rodriguez@pathwayhome.com",
    website: "pathwayhome.com/michael-rodriguez",
    nmls: "345678",
    photo: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=400&h=400&fit=crop&crop=face",
    bio: "Michael specializes in jumbo loans and investment property financing. His expertise in complex loan scenarios has helped hundreds of clients secure their dream homes."
  },
  {
    id: 4,
    name: "Lisa Chen",
    title: "Home Loan Advisor",
    phone: "(720) 555-0104",
    email: "lisa.chen@pathwayhome.com",
    website: "pathwayhome.com/lisa-chen",
    nmls: "456789",
    photo: "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=400&h=400&fit=crop&crop=face",
    bio: "Lisa focuses on USDA rural development loans and reverse mortgages. Her dedication to serving rural communities has made homeownership possible for many Colorado families."
  },
  {
    id: 5,
    name: "David Thompson",
    title: "Home Loan Advisor",
    phone: "(720) 555-0105",
    email: "david.thompson@pathwayhome.com",
    website: "pathwayhome.com/david-thompson",
    nmls: "567890",
    photo: "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=400&h=400&fit=crop&crop=face",
    bio: "David specializes in Non-QM loans and self-employed borrower programs. His innovative approach helps clients with unique financial situations achieve their homeownership goals."
  }
];

export const mockLoanPrograms = [
  {
    id: "fha",
    name: "FHA Loans",
    description: "Federal Housing Administration loans are perfect for first-time homebuyers with lower down payment requirements and flexible credit guidelines.",
    features: [
      "Down payments as low as 3.5%",
      "Credit scores as low as 580",
      "Lower mortgage insurance premiums",
      "Assumable loans"
    ]
  },
  {
    id: "va",
    name: "VA Loans",
    description: "Exclusive benefits for veterans, active military, and eligible spouses with no down payment required and no private mortgage insurance.",
    features: [
      "No down payment required",
      "No private mortgage insurance (PMI)",
      "Competitive interest rates",
      "No prepayment penalties"
    ]
  },
  {
    id: "usda",
    name: "USDA Rural Development",
    description: "Zero down payment loans for eligible rural and suburban areas, designed to promote homeownership in less densely populated areas.",
    features: [
      "100% financing available",
      "Lower mortgage insurance",
      "Income limits apply",
      "Property must be in eligible area"
    ]
  },
  {
    id: "jumbo",
    name: "Jumbo Loans",
    description: "High-balance mortgages that exceed conforming loan limits, perfect for luxury homes and high-cost areas.",
    features: [
      "Loan amounts above conforming loan limits",
      "Competitive rates for qualified borrowers",
      "Various term options",
      "Investment property options available"
    ]
  },
  {
    id: "dscr",
    name: "DSCR Loans",
    description: "Debt Service Coverage Ratio loans for real estate investors, qualifying based on property cash flow rather than personal income.",
    features: [
      "Qualify based on rental income",
      "No personal income documentation",
      "Perfect for investors",
      "Various property types accepted"
    ]
  },
  {
    id: "non-qm",
    name: "Non-QM Loans",
    description: "Non-Qualified Mortgage programs for borrowers who don't fit traditional lending guidelines but have the ability to repay.",
    features: [
      "Bank statement programs for self-employed",
      "Asset-based qualification",
      "Interest-only payment options",
      "Foreign national programs",
      "ITIN borrower programs",
      "No ratio loans",
      "Fix and flip financing"
    ]
  },
  {
    id: "home-equity",
    name: "Home Equity Loans & Lines",
    description: "Access your home's equity with fixed-rate loans or flexible lines of credit for home improvements, debt consolidation, or other needs.",
    features: [
      "Competitive fixed rates",
      "Flexible credit lines",
      "No cash-out restrictions",
      "Fast approval process"
    ]
  },
  {
    id: "reverse",
    name: "Reverse Mortgages",
    description: "FHA HECM loans for homeowners 62 and older to access home equity without monthly mortgage payments.",
    features: [
      "No monthly mortgage payments",
      "Access home equity",
      "Remain in your home",
      "FHA insurance protection"
    ]
  }
];